<div class="footer">
    <div class="footer-text">Copyright {{currentYear}} © AIM-Advanced Identification Methods GmbH - Built in Leipzig with 🎔 - V2.0.1</div>
<!--     <div class="footer-links">
        <a href="https://www.metabarcoding.com/imprint" class="footer-link" target="_blank">{{'Imprint' |
            translate}}</a>
        <a href="https://www.metabarcoding.com/privacy" class="footer-link" target="_blank">{{'Privacy Policy' |
            translate}}</a>
        <a href="https://heydata.eu" target="_blank" title="heyData GDPR seal" class="footer-logo">
            <img alt="heyData trusted logo"
                src="https://privacy-seal.heydata.eu/seal/07bee25e-319a-4aa6-9e08-567767d16d26?lang=de&design=design2&sealType=GDPR"
                width="80" height="80" style="border: 0" />
        </a>
    
        <div class="footer-logo-2fa" title="Two-Factor Authentication Secured">
            <img src="assets/images/Bild.png" alt="2FA Security" />
        </div>
        <div class="footer-logo-madeingermany" title="Software Made in Germany seal">
            <img src="assets/images/Bild_made.png" alt="Software Made in Germany" />
        </div>

        
    </div> -->
</div>